import React from 'react';
import { motion } from 'framer-motion';
import { Sun, Zap, Moon } from 'lucide-react';
export function ProtocolTable() {
  const steps = [{
    number: '10',
    icon: Sun,
    period: 'Mañana',
    action: '10 minutos en la mañana',
    why: "Le enseñas a tu cuerpo 'es día, estamos seguras'"
  }, {
    number: '3',
    icon: Zap,
    period: 'Día',
    action: '3 resets rápidos durante el día',
    why: 'Evitas acumular estrés silencioso que explota en la madrugada'
  }, {
    number: '1',
    icon: Moon,
    period: 'Noche',
    action: '1 rutina nocturna + Plan 3am',
    why: 'Evitas convertir un despertar normal en un espiral de ansiedad'
  }];
  return <section className="py-20 bg-white px-4" data-id="element-168">
      <div className="max-w-5xl mx-auto" data-id="element-169">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-170">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-171">
            Lo que hace diferente a la guía de este ebook
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-172">
            Aquí no vas a encontrar un "método mágico". Vas a encontrar el{' '}
            <span className="font-bold text-[#0d9488]" data-id="element-173">Protocolo 10–3–1</span>:
          </p>
        </motion.div>

        <div className="grid gap-6 md:gap-8" data-id="element-174">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="flex flex-col md:flex-row items-center bg-[#fef3e2]/30 rounded-2xl overflow-hidden border border-[#fef3e2]" data-id="element-175">
              {/* Number Column */}
              <div className="w-full md:w-32 bg-[#0d9488] p-6 flex flex-col items-center justify-center text-white shrink-0" data-id="element-176">
                <span className="text-4xl font-bold font-serif" data-id="element-177">
                  {step.number}
                </span>
                <step.icon className="w-6 h-6 mt-2 opacity-80" data-id="element-178" />
              </div>

              {/* Content Columns */}
              <div className="flex-1 p-6 md:p-8 grid md:grid-cols-2 gap-6 w-full" data-id="element-179">
                <div data-id="element-180">
                  <h3 className="text-sm font-bold text-[#0d9488] uppercase tracking-wider mb-2" data-id="element-181">
                    Qué haces
                  </h3>
                  <p className="text-lg font-semibold text-slate-900" data-id="element-182">
                    {step.action}
                  </p>
                </div>
                <div data-id="element-183">
                  <h3 className="text-sm font-bold text-[#0d9488] uppercase tracking-wider mb-2" data-id="element-184">
                    Por qué importa
                  </h3>
                  <p className="text-lg text-slate-700" data-id="element-185">{step.why}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="mt-12 text-center" data-id="element-186">
          <p className="text-lg md:text-xl text-slate-800 font-medium" data-id="element-187">
            Lo más importante:{' '}
            <span className="text-[#0d9488] font-bold" data-id="element-188">
              no te deja sola en el momento crítico.
            </span>
            <br data-id="element-189" />
            Te da un guion claro para cuando despiertas a las 3am.
          </p>
        </motion.div>
      </div>
    </section>;
}